import Button from '@payaca/components/button/Button';
import UntitledIcon from '@payaca/untitled-icons';

type Props = {
  isUploadingCsv: boolean;
  onUploadFile: (file: File) => void;
};
const UploadTemplateSection = ({ isUploadingCsv, onUploadFile }: Props) => {
  return (
    <div className="upload-button-wrapper">
      <Button type={'submit'} isProcessing={isUploadingCsv}>
        <div className="icon-wrapper">
          <UntitledIcon name="upload-01.3" />
        </div>
        <span>Upload</span>
      </Button>
      <label htmlFor={`file-upload`}></label>
      <input
        id={'file-upload'}
        type="file"
        accept=".csv"
        onChange={(e) => {
          // prevent file upload if mid-validate/upload
          if (!isUploadingCsv && e?.target?.files?.[0]) {
            onUploadFile(e.target.files[0]);
          }
          // Allow uploading of the same file
          if (e.target && e.target.value) {
            e.target.value = '';
          }
        }}
        hidden
      ></input>
    </div>
  );
};

export default UploadTemplateSection;
